module.exports = {"410171111":"九龙镇","410171560":"郑州经济技术开发区明湖街道","410171561":"郑州经济技术开发区潮河街道","410171562":"郑州经济技术开发区京航街道","410171563":"郑州经济技术开发区前程街道","410171565":"郑州经济技术开发区祥云街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410171.json
// module id = 1639
// module chunks = 0